import { render, staticRenderFns } from "./FiatConvertor.vue?vue&type=template&id=8dea6a20&scoped=true&"
import script from "./FiatConvertor.vue?vue&type=script&lang=js&"
export * from "./FiatConvertor.vue?vue&type=script&lang=js&"
import style0 from "./FiatConvertor.vue?vue&type=style&index=0&id=8dea6a20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dea6a20",
  null
  
)

export default component.exports